(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-bundle-shipping"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  if (!window.jQuery) return;
  window.jQuery(window).on('cc-variant-updated.bbBundleShipping', function (event, selection) {
    if (!selection || !selection.product) return;
    document.querySelectorAll('[data-bb-shipping-product]').forEach(function (message) {
      if (message.dataset.bbShippingProduct !== String(selection.product.id)) return;
      message.hidden = !(selection.variant && selection.variant.available && selection.variant.price >= 7500);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
